import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import ArpRegistry from '../../../../../features/arp-registry/ArpRegistry'
import { useAuth } from '../../../../hooks/useAuth'
import { styled } from '../../../../lib/stitches'
import { useTreeState } from '../../../../stores/Root'
import { requiresUserLoggedIn } from '../../../AuthFlow/AuthFlowModal'
import { Box } from '../../../core/Components'
import { segmentStudioButton } from '../../../studio/StudioUtils'
import UploadModal from '../upload-modal'
import MintModalSteps from './MintModalSteps'

export const StyledButton = styled('button', {
  all: 'unset',
  width: '32px',
  height: '32px',
  borderRadius: '8px',
  background: '$gray15',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '12px',
  color: '$gray01',
  lineHeight: '16px',
  fontWeight: '$medium',
  transition: 'all 200ms ease',
  '&:hover': {
    opacity: '.8'
  },
  '&:active': {
    opacity: '.6'
  }
})

const MintButton: FC = observer((props) => {
  const { studio } = useTreeState()

  return (
    <StyledButton
      css={{ marginRight: '4px', width: '100px' }}
      disabled={studio.loading || !ArpRegistry.readyForStudioUse}
      onClick={() => {
        segmentStudioButton('Mint Song', 'studio header')
      }}
    >
      Mint
    </StyledButton>
  )
})

const MintModal: FC = observer((props) => {
  const { user } = useAuth()
  const trigger = requiresUserLoggedIn(<MintButton />)

  if (!user) {
    return trigger
  }

  return (
    <UploadModal
      title="Mint your song"
      steps={[
        { name: 'Song details + Preview' },
        { name: 'Loading', hideClose: true },
        { name: 'Success', hideClose: true }
      ]}
      trigger={<Box>{trigger}</Box>}
      contentCSS={{ maxWidth: 'max-content' }}
    >
      <MintModalSteps />
    </UploadModal>
  )
})

export default MintModal
